<style></style>

<template>
    <div>
        <h2 class="mt-3">What would you like to do next?</h2>
        <div>
            <a v-bind:href="url" v-if="userIsProgram" class="btn btn-orange-blue">Start Another Action Plan!</a>
            <button 
                v-on:click="$emit('goalreached')"
                class="btn btn-orange-blue"
                v-show="actionPlan.date_completed === null"
            >
                I Reached This Goal!
            </button>
        </div>
    </div>
</template>

<script>
    import Auth from '../../auth.js'
    export default {
        props: {
            actionPlan: {
                required: true,
                type: Object
            },
            section: {
                required: true,
                type: Object
            },
            mostRecentAssessment: {
                required: true,
                type: Object
            }
        },
        data() {
            return {}
        },
        computed: {
            isComplete: function () {
                return (this.actionPlan.date_completed !== null)
            },
            url: function () {
                return this.$basePath+'/action-plans/'+this.mostRecentAssessment.survey.slug+'/'+this.mostRecentAssessment.id+'/start'
            },
            userIsProgram(){
                return Auth.is('program-user')
            },
            $basePath() {
              return window.basePath;
            }
        },
        methods: {}
    
}
</script>